import React, { Component } from 'react';
import Content from '../../components/Content';
import { tvchannels, accordions } from '../../services/a1';

class TVPaketi extends Component {
  componentDidMount() {
    document.title = 'ТВ пакети - A1 Xplore TV GO';
  }

  render() {
    return (
      <>
        <Content resource="TVPaketi" />
        <Content
          resource="TVChannels"
          callback={() => {
            tvchannels();
            accordions();
          }}
        />
      </>
    );
  }
}

export default TVPaketi;
